import type { LlanaListResponse, LlanaSocketData, LlanaListOptions } from '~/types/llana'
import type { Forum } from '~/types/forum'

const table_name = 'forums'
type T = Forum
const default_sort = 'priority.asc'
const default_limit = 999
const default_relations = undefined

export class ForumStore extends baseStore<T> {
	constructor() {
		super({
			table_name,
			store_name: table_name,
			default_sort,
			default_limit,
			default_relations
		})
	}
}

export const useForumStore  = () => defineStore(table_name, {
	state: () => <LlanaListResponse<T>>defaultList(),
	actions: {
		async bindEvents(where?: { [key: string]: string | number }) {
			const { $llanaSubscribe } = useNuxtApp()
			await $llanaSubscribe(
				table_name,
				(data: LlanaSocketData) => this.get(data.id as number, where),
				(data: LlanaSocketData) => this.get(data.id as number, where),
				(data: LlanaSocketData) => this.remove(data.id as number, where),
			)
		},
		async create(data: T) {
			const store = new ForumStore()
			const { state, record } = await store.create(this.$state, data)
			this.$state = state
			return record
		},
		async get(id: number, where?: { [key: string]: string | number }): Promise<T | undefined> {
			const store = new ForumStore()
			const { state, record } = await store.get(this.$state, id, where)
			this.$state = state
			return record
		},
		async list(options?: LlanaListOptions): Promise<LlanaListResponse<T>> {
			const store = new ForumStore()
			this.$state = await store.list(this.$state, options)
			return this.$state
		},
		async search(options?: LlanaListOptions): Promise<LlanaListResponse<T>> {
			const store = new ForumStore()
			return await store.search(options)
		},
		async reload(): Promise<LlanaListResponse<T>> {
			const store = new ForumStore()
			this.$state = await store.reload()
			return this.$state
		},
		async update(id: number, data: Partial<T>): Promise<T> {
			const store = new ForumStore()
			const { state, record } = await store.update(this.$state, id, data)
			this.$state = state
			return record
		},
		async remove(id: number, where?: { [key: string]: string | number }): Promise<void> {
			const store = new ForumStore()
			this.$state = await store.remove(this.$state, id, where)
		},
		async delete(id: number): Promise<void> {
			const store = new ForumStore()
			this.$state = await store.delete(this.$state, id)
		},
	},
})
